// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* .MuiTypography-root {
  font-family: "Outfit", "Inter", sans-serif;
} */

.user-name {
  font-weight: bold !important;
  line-height: normal !important;
  font-size: 18px;
}

.view-profile-text  {
  font-size: 0.8rem !important;
  color: red;
  margin-top: 0.5rem !important;
  letter-spacing:normal !important;
  display: flex;
  align-items: center;
}

.menu-container {
  padding: 1rem;
  height: 100vh;
}

.dark {
  color: white;
}

.route-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex: 1;
  gap: 0.2rem;
  box-shadow: rgba(17, 17, 26, 0.1) 0px 0px 16px;
  padding: 0.5rem;
  border-radius: 1rem;
  min-width: 4rem;
  background-color: #fff;
  font-size: 12px;
  font-weight: 600;
}

.dark .route-card {
  background-color: #3a415f;
}

.profile-pic {
  width: 4rem;
  height: 4rem;
  border-radius: 50%;
  object-fit: cover;
  border: 1.5px solid #999;
}

.settings-card {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.settings-card-icon {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 35px;
  height: 35px;
  border-radius: 50%;
  background-color: #f5f5f5;
}

.dark .settings-card-icon {
  background-color:#50578a;
}

.settings-card-icon svg {
  font-size: 1.2rem;
  color: #5f5f5f;
}

.dark .settings-card-icon svg {
  color: #fff;
}

.settings-card-content {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.user-details-card {
  background-color: #fff;
  box-shadow: rgba(17, 17, 26, 0.1) 0px 0px 16px;
  padding: 1rem;
  border-radius: 1rem;
}

.dark .user-details-card {
  background-color: #3a415f;
}

.settings-container {
  background-color: #fff;
  box-shadow: rgba(17, 17, 26, 0.1) 0px 0px 16px;
  padding: 1rem;
  border-radius: 1rem;
  font-size: 14px;
  font-weight: 500;
}

.dark .settings-container {
  background-color: #3a415f;
}

.fixed-icon-container {
  position: fixed;
  bottom: 1rem;
  right: 1rem;
  border-radius: 50%;
  background-color: #fff;
  box-shadow: rgba(17, 17, 26, 0.1) 0px 1px 0px, rgba(17, 17, 26, 0.1) 0px 8px 24px, rgba(17, 17, 26, 0.1) 0px 16px 48px;
  z-index: 9999;
}

.dark .fixed-icon-container {
  background-color: #3a415f;
}`, "",{"version":3,"sources":["webpack://./client/src/layouts/ecommerce/product/all-products/Menu.css"],"names":[],"mappings":"AAAA;;GAEG;;AAEH;EACE,4BAA4B;EAC5B,8BAA8B;EAC9B,eAAe;AACjB;;AAEA;EACE,4BAA4B;EAC5B,UAAU;EACV,6BAA6B;EAC7B,gCAAgC;EAChC,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,aAAa;AACf;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,OAAO;EACP,WAAW;EACX,8CAA8C;EAC9C,eAAe;EACf,mBAAmB;EACnB,eAAe;EACf,sBAAsB;EACtB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,8CAA8C;EAC9C,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,8CAA8C;EAC9C,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,sBAAsB;EACtB,sHAAsH;EACtH,aAAa;AACf;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":["/* .MuiTypography-root {\n  font-family: \"Outfit\", \"Inter\", sans-serif;\n} */\n\n.user-name {\n  font-weight: bold !important;\n  line-height: normal !important;\n  font-size: 18px;\n}\n\n.view-profile-text  {\n  font-size: 0.8rem !important;\n  color: red;\n  margin-top: 0.5rem !important;\n  letter-spacing:normal !important;\n  display: flex;\n  align-items: center;\n}\n\n.menu-container {\n  padding: 1rem;\n  height: 100vh;\n}\n\n.dark {\n  color: white;\n}\n\n.route-card {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  flex: 1;\n  gap: 0.2rem;\n  box-shadow: rgba(17, 17, 26, 0.1) 0px 0px 16px;\n  padding: 0.5rem;\n  border-radius: 1rem;\n  min-width: 4rem;\n  background-color: #fff;\n  font-size: 12px;\n  font-weight: 600;\n}\n\n.dark .route-card {\n  background-color: #3a415f;\n}\n\n.profile-pic {\n  width: 4rem;\n  height: 4rem;\n  border-radius: 50%;\n  object-fit: cover;\n  border: 1.5px solid #999;\n}\n\n.settings-card {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.settings-card-icon {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 35px;\n  height: 35px;\n  border-radius: 50%;\n  background-color: #f5f5f5;\n}\n\n.dark .settings-card-icon {\n  background-color:#50578a;\n}\n\n.settings-card-icon svg {\n  font-size: 1.2rem;\n  color: #5f5f5f;\n}\n\n.dark .settings-card-icon svg {\n  color: #fff;\n}\n\n.settings-card-content {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.user-details-card {\n  background-color: #fff;\n  box-shadow: rgba(17, 17, 26, 0.1) 0px 0px 16px;\n  padding: 1rem;\n  border-radius: 1rem;\n}\n\n.dark .user-details-card {\n  background-color: #3a415f;\n}\n\n.settings-container {\n  background-color: #fff;\n  box-shadow: rgba(17, 17, 26, 0.1) 0px 0px 16px;\n  padding: 1rem;\n  border-radius: 1rem;\n  font-size: 14px;\n  font-weight: 500;\n}\n\n.dark .settings-container {\n  background-color: #3a415f;\n}\n\n.fixed-icon-container {\n  position: fixed;\n  bottom: 1rem;\n  right: 1rem;\n  border-radius: 50%;\n  background-color: #fff;\n  box-shadow: rgba(17, 17, 26, 0.1) 0px 1px 0px, rgba(17, 17, 26, 0.1) 0px 8px 24px, rgba(17, 17, 26, 0.1) 0px 16px 48px;\n  z-index: 9999;\n}\n\n.dark .fixed-icon-container {\n  background-color: #3a415f;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
